<template>
  <div>
    <el-container style="height:100vh;">
      <el-aside class='x-flex' style='width: unset;position: relative;overflow: unset;'>
        <!-- 主菜单 -->
        <div class="main-menu" style="background: #031A43;">
          <div class="x-flex  x-row-center x-p-t-20  x-p-b-10">
            <img  :src="$store.state.oem.logo" style="width: 50rem;height: 50rem;" alt="">
          </div>
          <div class="main-menu-top-level">
            <ul class="infinite-list">
              <li @mouseover="mouseover(i, $event)" @mouseleave="hoverMouseleave" v-for="(i, index) in navList"
                class="infinite-list-item x-p-l-6" :class="{ 'main-menu-style': i.select }" @click="navListClick(i)"
                :key="index">

                <div class='x-flex'>
                  <img :src="i.img" style="width: 16rem; height: 16rem; margin-top: 2rem;">
                  <!-- <img v-if="i.select" :src="i.act_img" style="width: 16rem; height: 16rem; margin-top: 2rem;"> -->
                  <!-- <img v-else :src="i.img" style="width: 16rem; height: 16rem; margin-top: 2rem;"> -->
                  <div class="x-p-l-5 x-font-14">
                    {{ fLng(i.name, 'index') }}
                  </div>
                </div>

              </li>
            </ul>
          </div>
        </div>

        <!-- 固定子菜单 点击显示  -->
        <!-- <div class="bgc-f x-w130 x-h100p x-bd-right" style="overflow-x: hidden;" v-if='false'>
          <div class="c-0 x-text-l x-m-l-20 x-p-t-10 x-p-b-6 x-font-15  ">
            {{ fLng(fixSubTitle, 'index') }}
          </div>
          <el-menu @open="" @close="" :default-openeds="openeds" :default-active="activerouter">
            <el-submenu v-for="(item, index) in fixSubNavList" :index="String(item.id)" :key="item.id">
              <template slot="title">
                <span style='color:#999999'>{{ fLng(item.show_name || item.name, 'index') }}</span>
              </template>
<el-menu-item v-for="(item1, index1) in item.children" :index="String(item1.id)" :key="item1.id"
  :class="item1.select ? 'is-active' : ''" @click="subNavItemClick(item1)">{{ fLng(item1.show_name ||
  item1.name, 'index') }}</el-menu-item>
</el-submenu>
</el-menu>
</div> -->

        <!-- 悬浮子菜单 鼠标移动该盒子显示隐藏   highlight-current 高光  moveDisplaySub-->

      </el-aside>
      <el-container style="overflow: auto;min-width: 800rem;background: #031A43;">
        <el-header height="" class="x-flex x-row-between x-w100p x-p-t-10 x-p-b-10 f500"
          style="border-radius: 10rem 0 0 0;background-color: #dae5fc;">
          <div class="x-flex">
            <!-- <div class="x-m-r-5 x-p-r-5 x-bd-right">
              <i class="el-icon-s-home"></i>
            </div> -->
            <div
              style="font-size: 14rem;background-color: #1d3258;border-radius: 25px;padding: 4px 15rem;text-align: center;margin-right: 10rem;color: #fff;">
              标准版
            </div>
            <div class='x-m-r-20 ' style=" font-size: 14rem;color: #333;font-weight: 400;">
              {{ $store.state.djsAdmin.mall_name }} <span>（{{ fLng('商户号', 'index') }}：{{
                $store.state.djsAdmin.mch_id }}）</span>
            </div>
            <!-- <div class="x-font-14 x-p-l-5">
              {{ firstTitle }} / {{ breadcrumb }}
            </div> -->
          </div>
          <div class="right">
            <!-- 点击展示搜索功能 -->
            <div class="x-flex x-rela">
              <div class="x-flex x-font-14 x-p-r-20 x-cur-poi " @click="showSearch = !showSearch" ref="searchBtn">
                <img style="width: 16rem;height: 16rem;" src="../assets/img/navSearch.png" alt="" />
                <div>功能搜索</div>
              </div>
              <transition name="search-fade">
                <div class="search-popup" v-if="showSearch" v-click-outside="fCloseSearchPopup">
                  <el-select v-model="navSelectVal" size="small" filterable placeholder="搜索功能菜单" @change="fNav">
                    <el-option v-for="item in allNavList" :key="item.path" :label="item.name" :value="item.path">
                    </el-option>
                  </el-select>
                </div>
              </transition>
            </div>

            <!-- 搜索浮窗 -->


            <div class="x-flex x-font-14 x-p-r-20 x-cur-poi">
              <img style="width: 16rem;height: 16rem;" src="../assets/img/navXxzx.png" alt="" />
              <div>消息中心</div>
            </div>
            <div class="x-flex x-font-14 x-p-r-20 x-cur-poi">
              <img style="width: 16rem;height: 16rem;" src="../assets/img/navBzzx.png" alt="" />
              <div>帮助中心</div>
            </div>

            <div class="x-m-r-10" style="width: 2px;height: 16rem;background-color: #c4cdd5;"></div>
            <img src="../assets/img/user_logo.png" alt="" />
            <el-dropdown>
              <span class="el-dropdown-link x-cur-poi c-0">
                {{ $store.state.djsAdmin.user_name }} {{ $store.state.djsAdmin.user_id }}<i
                  class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="changePassword = true">{{ fLng('修改密码', 'index') }}</div>
                </el-dropdown-item>
                <el-dropdown-item v-if="$store.state.djsAdmin.mall_num > 1">
                  <div @click="logout('switchMall')">{{ fLng('切换门店', 'index') }}</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="logout('logout')">{{ fLng('退出登录', 'index') }}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <div style="background-color: #fff;">
          <Tabs class='bgc-f' style="width: 100%; height: 40rem; " @refresh-page="refresh" />
        </div>
        <el-main class='x-flex-1 x-w100p bgc-f' style='overflow: auto;min-width: 800rem;'>
          <!-- <el-card style="width: 100%; height: 70rem"> -->
          <!-- </el-card> -->
          <keep-alive>
            <router-view ref="mainView" :key="$route.fullPath" />
          </keep-alive>

          <!-- <router-view style='min-height:700rem;'></router-view> -->
        </el-main>
      </el-container>
    </el-container>
    <!-- 修改密码的弹窗 -->
    <el-dialog :visible.sync="changePassword" width="400px" :close-on-click-modal="false" :show-close="false"
      :close-on-press-escape="false" class="pl-edit-dialog">
      <div class="x-sm-pop-head">
        <div class="x-flex">
          <div class='x-flex x-h50 x-m-r-20'>{{ fLng('绑定手机号', 'vip') }}
          </div>
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;"
            @click="changePassword = false"></i>
        </div>
      </div>
      <div class="x-w100p x-p-30" style="padding-bottom:0 ;">
        <!-- 旧密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>旧密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="oldPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 新密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>新密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="newPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 确认密码 -->
        <div class="x-w100p x-h42  x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>确认密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="confirmPassword" placeholder="" show-password></el-input>
          </div>
        </div>

      </div>
      <!-- 确定&取消 -->
      <div class="x-sm-pop-foot">
        <xButton width="70px" class="x-p-l-10" border="1px solid #DCDFE6" bgc="#fff" color="#242424"
          @click.native="changePassword = false">取消</xButton>
        <xButton width="70px" class="x-p-l-10" @click.native="determineAdd">确定</xButton>
      </div>
    </el-dialog>
    <div class="bgc-f sub-nav-box" ref="subNavBox" :style="{
      position: 'absolute',
      left: subNavBoxLeft + 'rem',
      top: subNavBoxTop + 'rem',
      zIndex: 99,
      borderRadius: '5rem',
      boxShadow: '1rem 3rem 12rem 0rem rgba(0, 0, 0, 0.3)'
    }" v-if='moveDisplaySub' @mouseleave="mouseleave" @mouseover="hoverMouseover">
      <div class="x-flex   bgc-f x-col-start" style=" border-radius: 5rem;">
        <div style="flex-shrink: 0;" class="x-m-20 x-m-r-1" v-for="(item, index) in floatSubNavList" v-if="!item.isNav"
          :index="String(item.id)" :key="item.id">
          <div class="sub-nav-title">{{ item.name }}</div>
          <div v-for="(item1, index1) in item.children" :index="String(item1.id)" :key="item1.id"
            @click="subNavItemClick(item1)">
            <div class="sub-nav-item" :class="{ 'active-sub-nav-item': item1.select }">{{ item1.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '../assets/js/bus.js'
import Tabs from "@/components/tabs.vue";
import cyNavList from "@/assets/listData/cyNav.js";
import lsNavList from "@/assets/listData/lsNav.js";

export default {
  components: {
    Tabs,
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // 检查点击事件是否发生在元素外部，并且不是来自搜索按钮
          const searchBtn = vnode.context.$refs.searchBtn;
          if (!(el == event.target || el.contains(event.target)) &&
            !(searchBtn && (searchBtn == event.target || searchBtn.contains(event.target)))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  data() {
    return {
      showSearch: false,
      showImg: false,
      userName: this.$store.state.djsAdmin.userName,
      path: "/orgAdmin",
      firstTitle: '概况',
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
      openeds: ['100', '200', '201', '202', '203', '300', '301', '400', '500'],
      activerouter: '/dish',
      langList: [{
        label: '中文',
        value: 'zh-CN'
      }, {
        label: 'English',
        value: 'en-US'
      },],
      hoverActive: '',
      clickDisplaySub: false,
      breadcrumb: '营业概况',
      navList: [],
      //浮动子菜单数据
      floatSubNavList: [],
      //窗口大小
      screenWidth: document.body.offsetWidth,
      //固定子菜单数据
      fixSubNavList: [],
      //浮动子菜单标题
      floatSubTitle: '',
      //固定子菜单标题
      fixSubTitle: '',
      //侧边栏==点击显示子菜单
      clickDisplaySub: false,
      //侧边栏==移入显示子菜单
      moveDisplaySub: false,
      asideList: [],
      asideName: "",
      // 修改密码
      changePassword: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      breadcrumbPath: "",
      breadcrumbName: "",

      navSelectVal: '',
      subNavBoxLeft: 89, // 默认左边距
      subNavBoxTop: 0,   // 默认顶部
    };
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    },
    allNavList() {
      const list = [];
      this.navList.forEach(mainItem => {
        mainItem.data.forEach(subItem => {
          subItem.children.forEach(childItem => {
            list.push({
              name: childItem.name,
              path: childItem.path,
              mainName: mainItem.name, // 主菜单名称
              subName: subItem.name, // 子菜单名称
              authId: childItem.authId // 添加权限ID
            });
          });
        });
      });
      return list
      // 过滤掉没有权限的菜单项
      // return list.filter(item => {
      //   if (!item.authId) return true;
      //   const { user_id, user_auth_info } = this.$store.state.djsAdmin;
      //   return user_id === '1001' || (user_auth_info && user_auth_info.some(auth => auth.auth_id === item.authId));
      // });
    },
  },
  beforeCreate() {

  },
  created() {

    //根据版本显示菜单
    this.navList = this.$store.state.djsAdmin.saas_type_id == 'sipLs' ? lsNavList : cyNavList;
    eventBus.$on('fChangeBreadcrumb', (breadcrumbList) => {
      console.log(breadcrumbList)
      this.breadcrumbPath = breadcrumbList.path
      this.breadcrumbName = breadcrumbList.name
    })
    if (document.body.offsetWidth < 1280) {
      this.clickDisplaySub = false;
    } else {
      this.clickDisplaySub = true;
    }

    this.eventBus.$on('fRouteFail', () => {
      this.fSetActive('return')
    })
    this.fSetActive()
  },
  watch: {
    '$route': 'fSetActive', //监听路由变化
    moveDisplaySub(newVal) {
      console.log(newVal)
      if (document.body.offsetWidth < 1280) {
        this.clickDisplaySub = false;
      } else {
        this.clickDisplaySub = true;
      }
    },
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          that.reload(that.screenWidth); //窗口大小变化后执行的方法
          that.timer = false;
        }, 10);
      }
    },

  },
  mounted() {
    const that = this;
    window.onresize = () => (() => {
      window.screenWidth = document.body.offsetWidth;
      that.screenWidth = window.screenWidth;
    })();
  },
  methods: {
    // 关闭搜索浮窗
    fCloseSearchPopup() {
      console.log('关闭搜索', this.showSearch)
      if (this.showSearch) {
        this.showSearch = false;
      }
    },
    refresh(path) {
      // 只在当前激活页面时刷新
      if (path === this.$route.path) {
        this.$nextTick(() => {
          const pageComp = this.$refs.mainView;
          if (pageComp && typeof pageComp.init === 'function') {
            pageComp.init();
            console.log(pageComp);
          } else {
            // 没有 init 方法可以提示
            // this.$message && this.$message.warning('当前页面未实现init方法');
          }
        });
      } else {
        // 跳转后刷新
        this.$router.push(path);
        this.$nextTick(() => {
          const pageComp = this.$refs.mainView;
          if (pageComp && typeof pageComp.init === 'function') {
            pageComp.init();
          }
        });
      }
    },
    //设置选中状态
    // 设置选中状态
    fSetActive(type) {
      console.log(type, 'type')
      let isRotuer = type
      // 获取地址栏中的路由
      let defaultMenu = window.location.hash.substr(
        window.location.hash.indexOf("/")
      );
      this.activerouter = defaultMenu.split('?')[0].slice(1);
      // 取前缀
      if (this.activerouter.split('_')[0].length > 1) {
        this.activerouter = this.activerouter.split('_')[0]
        isRotuer = 'return'
      }
      // 设置主菜单和子菜单选中状态
      let data = []
      this.firstTitle = '概况'
      this.navList.forEach((item) => {
        this.breadcrumb = '营业概况'
        // 检查是否有子菜单
        if (item.data && item.data.length > 0) {
          item.data.forEach(item1 => {
            item1.children.forEach(item2 => {
              if (item2.path == '/' + this.activerouter) {
                data = item2
                this.firstTitle = item.name
                this.breadcrumb = item1.name + ' / ' + item2.name //item2.navTitle
                return
              }
              if (this.activerouter == 'vipDetail') {
                data = {
                  id: 300001,
                  path: '/vip',
                  name: '会员信息',
                  navTitle: "档案信息 / 会员信息"
                }
                this.firstTitle = '会员'
                this.breadcrumb = '档案信息 / 会员信息'
                isRotuer = 'return'
                return
              }
              if (this.activerouter == 'vipDhJl') {
                data = {
                  id: 300005,
                  path: '/vipDhLp',
                  name: '兑换礼品',
                  navTitle: "档案信息 / 兑换礼品"
                }
                this.firstTitle = '会员'
                this.breadcrumb = '档案信息 / 兑换礼品'
                isRotuer = 'return'
                return
              }
              if (this.activerouter == 'dxTzEdit') {
                data = {
                  id: 301001,
                  path: '/dxTz',
                  name: '短信通知',
                  navTitle: "会员运营 / 短信通知"
                }
                this.firstTitle = '会员'
                this.breadcrumb = '会员运营 / 短信通知'
                isRotuer = 'return'
                return
              }
            })
          })
        } else {
          // 没有子菜单的情况，直接匹配主菜单路径
          if (item.path == '/' + this.activerouter) {
            data = {
              id: item.id,
              path: item.path,
              name: item.name
            }
            this.firstTitle = item.name
            this.breadcrumb = item.name
            return
          }
        }
      });
      this.subNavItemClick(data, isRotuer)
    },
    // 鼠标进主菜单
    hoverMouseleave(navItem) {
      this.navActSelId = navItem.id
    },
    mouseover(navItem, event) {


      this.floatSubTitle = navItem.name;
      this.navActSelId = navItem.id;
      // 检查是否有子菜单数据
      if (!navItem.data || navItem.data.length === 0) {

        this.moveDisplaySub = false;
        return; // 如果没有子菜单，直接返回，不显示弹窗
      }
      this.floatSubNavList = navItem.data;
      this.moveDisplaySub = true;

      // 获取当前一级菜单元素的位置信息
      let target = event.target;
      if (target.tagName !== 'LI') {
        target = target.closest('li');
      }
      if (target) {
        const rect = target.getBoundingClientRect();
        this.subNavBoxLeft = rect.right;
        let top = rect.top + window.scrollY;
        // 等待浮层渲染后再计算
        this.$nextTick(() => {
          const subNavBox = this.$refs.subNavBox;

          if (subNavBox) {
            const floatHeight = subNavBox.offsetHeight;
            const windowHeight = window.innerHeight;
            // 向上平移一个菜单项高度
            top = top - 40;
            // 如果浮层底部超出窗口底部
            if (top + floatHeight > windowHeight + window.scrollY) {
              // 防止平移后超出顶部
              if (top < 0) top = 0;
            }
            this.subNavBoxTop = top;
          } else {
            this.subNavBoxTop = top;
          }
        });
      }
    },
    //鼠标移入悬浮子菜单
    hoverMouseover() {
      this.hoverActive = this.floatSubTitle
    },
    //鼠标离开子菜单 隐藏悬浮子菜单
    mouseleave() {
      this.hoverActive = ''
      this.moveDisplaySub = false;
    },
    async fNav(path) {
      console.log(path)
      if (this.api.smCom.fSmIsEmpty(path)) {
        return
      }
      if (path == -1 || path == -2) {
        window.history.go(path)
      } else {
        // 查找对应的菜单项以获取authId
        const navItem = this.allNavList.find(item => item.path === path);
        if (navItem && navItem.authId) {
          // 检查权限
          const resPower = await this.fGetSmMenuQx(navItem.authId);
          if (!resPower.resolve) {
            return this.$message.error('没有' + navItem.name + '的权限');
          }
        }
        this.$router.replace(path);
      }
      this.breadcrumbPath = ''
      this.breadcrumbName = ''
      setTimeout(() => {
        this.navSelectVal = ''
      }, 200)
    },
    // 点击主菜单
    navListClick(navItemData) {
      //找到当前的子菜单的数据
      this.subNavItemClick(navItemData);
    },
    // 子菜单的点击事件
    async subNavItemClick(itemData, type) {
      let resPower = await this.fGetSmMenuQx(itemData.authId)
      console.log(itemData.authId)
      if (!resPower.resolve) {
        return this.$message.error('没有' + itemData.name + '的权限')
      }
      this.breadcrumbPath = ''
      let navId = itemData.id + '';
      console.log(itemData)

      //取子菜单的id 前两位 取主菜单id
      this.navActSelId = navId.substring(0, 2);
      // 设置主菜单和子菜单选中状态
      this.navList.map(async (item) => {
        if (item.id == this.navActSelId || item.id == itemData.id) {
          item.select = true
          this.floatSubNavList = item.data
          this.fixSubNavList = item.data
          // 默认展开
          // this.openeds = []
          this.fixSubNavList.forEach(item => {
            // 如果id大于4位说明点击子菜单
            if (String(itemData.id).length > 4) {
              item.children.forEach(item1 => {
                if (item1.id == itemData.id) {
                  this.lookForAllId(this.navList)
                  item1.select = true
                  this.breadcrumb = item.name + ' / ' + item1.name
                  this.lastNavACt = this.navActSelId
                }
                return
              })
            } else { }
          })
          if (item.id == this.navActSelId) {
            this.floatSubTitle = item.name
            this.fixSubTitle = this.floatSubTitle
          }
          console.log('跳转取消return')
          // 直接跳转
          if (type != 'return') {
            //判断权限
            this.mouseleave()
            this.$router.push(itemData.path);
          }
        } else {
          item.select = false
        }
      });

    },
    lookForAllId(data = []) {
      for (let item of data) {
        if (String(item.id).length > 4) {
          item.select = false
        }
        if (item.data && item.data.length) {
          this.lookForAllId(item.data)
        }
        if (item.children && item.children.length) {
          this.lookForAllId(item.children)
        }
      }
    },
    // 注销登录
    logout(type) {
      if (type == 'switchMall') {
        this.$router.push("/mall_list");
      }
      if (type == 'logout') {
        this.$router.push("/login");
      }
    },
    reload(screewidth) {
      if (screewidth < 1280) {
        this.clickDisplaySub = false;
      } else {
        this.clickDisplaySub = true
      }
    },
    fChgLng(item) {
      this.$store.commit('lng', item.value);
      this.$store.commit('lng_name', item.name);

      window.location.reload();
      // this.$forceUpdate()
    },


    // ------------ 请求 开始 -------------

    // 修改密码=确定
    async determineAdd() {
      if (this.api.smCom.fSmIsEmpty(this.oldPassword)) {
        return this.$message(this.fLng('请输入旧密码', 'login'));
      }
      if (this.api.smCom.fSmIsEmpty(this.newPassword)) {
        return this.$message(this.fLng('请输入新密码', 'login'));
      }
      if (this.api.smCom.fSmIsEmpty(this.confirmPassword)) {
        return this.$message(this.fLng('请输入确认密码', 'login'));
      }
      if (this.newPassword == this.confirmPassword) {
        let res = await this.USER_CHG_PSW()
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.changePassword = false
        setTimeout(() => {
          //返回登录页面
          this.logout('logout')
        }, 2000);
      } else {
        this.$message.error('确认密码与修改的密码不一致！');
      }
    },
    // 修改密码  USER_CHG_PSW
    async USER_CHG_PSW(oper) {
      let js = {};
      js['OPER'] = 'CHG'
      js['USER_ID'] = this.$store.state.djsAdmin.user_id
      js['CHG_USER_ID'] = this.$store.state.djsAdmin.user_id
      js['OLD_PSW'] = this.oldPassword
      js['NEW_PSW'] = this.newPassword
      let res = await this.api.djsApi.fDjsAdminApi({
        methodName: 'USER_CHG_PSW',
        js,
      })
      return res;
    },
    // ------------ 请求 结束 -------------
  },
};
</script>

<style lang="less" scoped>
.el-aside {
  font-size: 16rem;
  height: 100vh;
  background-color: #031A43;
  // overflow-x: hidden;
  // overflow: hidden;

  .logo {
    width: 100%;
    height: 100%;
    // height: 80rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: auto;
      height: 40rem;
    }
  }

  .aside-item {
    color: #000000;
    height: 50rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .aside-item-active {
    background-color: #FFEEEA;
    color: #031A43;
  }
}

.el-header {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20rem;
  font-size: 16rem;
  font-weight: bold;

  .right {
    display: flex;
    align-items: center;
    font-weight: 500;

    img {
      width: 30rem;
      margin-right: 5rem;
      height: 30rem;
      border-radius: 50%;
    }
  }

  .right:hover {
    .edit-pwd {
      display: flex;
    }
  }
}

.el-main {
  background-color: #EBEDF6;
  padding: 10rem;
}


//element-ui 选择器三角
// /deep/.el-select__caret {
//   line-height: 32rem;
// }

// // 选择行高
// /deep/.el-input__icon {
//   line-height: 32rem;
// }

//所有表头背景颜色
/deep/.vxe-table {
  .vxe-table--header-wrapper {
    background: #F5F7FA !important;
  }
}

//element 按钮样式==颜色
/deep/.el-button--primary {
  background-color: #6396FC;
  border-color: #6396FC;
}

// 页选择的背景颜色
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #6396FC;
}

//单选文字颜色
/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #6396FC;
}

//单选按钮颜色
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #6396FC;
  background: #6396FC;
}

//图片样式
img {
  vertical-align: baseline;
}

.breadcrumb-item {
  cursor: pointer;

  &:hover {
    color: #1971FF;
  }
}

.main-menu {
  width: 89rem;
  height: 100%;

  .main-menu-top-level {
    height: calc(100vh - 46rem);
    overflow-y: auto;
    padding-left: 0rem;

    .infinite-list {
      .infinite-list-item {
        width: 100%;
        // text-indent: 20rem;
        height: 48rem;
        padding-left: 16rem;
        display: flex;
        justify-content: left;
        align-self: center;
        color: #fff;
        cursor: pointer;
        // position: relative;

        .block-element {
          display: inline-block;
          position: absolute;
          left: 10rem;
          top: 0rem;
          text-indent: 0rem;
        }
      }

      .main-menu-style {
        background-color: #007AFB !important;
        color: #fff !important;
      }

      .infinite-list-item:hover {
        background: #02377b;
        color: #fff;
      }

    }
  }


}

.sub-nav-title {
  width: 100rem;
  font-size: 14rem;
  font-weight: bold;
  position: relative;
  padding-left: 10rem;
  margin-bottom: 10rem;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 3rem;
    width: 3rem;
    height: 14rem;
    background: #2D8CF0;
  }
}

.sub-nav-item {
  width: 90rem;
  font-size: 14rem;
  padding: 10rem 10rem;


}

.sub-nav-item:hover {
  color: #6897f9;
  cursor: pointer;
  border-radius: 4rem;
  background: #F5F5F5;

}

.active-sub-nav-item {
  background: #F5F5F5;

  color: #6897f9;

  border-radius: 4rem;
}

// 搜索浮窗样式
.search-popup {
  position: absolute;
  top: 120%;
  right: 0;
  background-color: #fff;
  padding: 10rem;
  border-radius: 4rem;
  box-shadow: 0 2rem 12rem 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200rem;
}

// 搜索浮窗出场动画
.search-fade-enter-active,
.search-fade-leave-active {
  transition: all 0.3s ease-out;
}

.search-fade-enter,
.search-fade-leave-to {
  opacity: 0;
  transform: translateY(-10rem);
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue